import { PropsOf } from 'types';
import App from './App';

export default App;
export type AppProps = PropsOf<ReturnType<typeof App>>;
